(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/background.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/background.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  Image
} = svs.content.image_v2;
const Background = _ref => {
  var _svs$eInstant$data$mo;
  let {
    children,
    classNames = ''
  } = _ref;
  const backgroundImg = (_svs$eInstant$data$mo = svs.eInstant.data.moduleConfig) === null || _svs$eInstant$data$mo === void 0 ? void 0 : _svs$eInstant$data$mo.lobbyContainerBackground;
  if (backgroundImg) {
    return React.createElement("div", {
      className: "tickets-einstant-background-img overflow-hidden u-position-relative ".concat(classNames)
    }, React.createElement(Image, {
      fit: true,
      image: _objectSpread(_objectSpread({}, backgroundImg), {}, {
        fitWrapper: true
      })
    }), children);
  }
  return React.createElement("div", {
    className: "tickets-einstant-stripe-background-container overflow-hidden ".concat(classNames)
  }, children);
};
setGlobal('svs.eInstant.shared.components.Background', Background);

 })(window);